export default __webpack_public_path__ + "static/media/image-study-board-1-m@3x.ce17ba62.webp";